import React, {Component} from 'react';
import {Button, Input, Select, Space, Switch} from 'antd';
import IconSettings from "../../iconfont/topEdit/settings";
import ZkModal from "../../../common/modal/zkModal";
import ZKTable from "../../../common/table/zkTable";
import CloudApi from "../../../cloud/cloud_api";
import Message from "../../../common/message";
import ZkWxClient from "../../../cloud/common/zkWxClient/zkWxClient";
import ImLogin from "../login/imLogin";
import TableTip from "./tableTip";


const {Search} = Input;
const {Option} = Select;

class TopEdit extends Component {

    state = {
        zkParams: {
            nickName: '',
            loginStatus: '',
        },

        searchValue: '',

        total: 0,
        //登录组件的值
        data: {
            avatar: '',
            nickname: '',
            shortCorpName: '',
        },
        wxid: ''
    }


    //开关回调
    switch = (wxid, openChat, e) => {
        const {getData, queryLinkMan} = this.props
        let bodyData = {
            wxid: wxid,
            openChat: openChat,
        }
        CloudApi.doChatSettingsRadio(bodyData, data => {
            if (openChat == 1) {
                // Message.success('已开启')
                // getData()
            } else {
                // Message.success('已关闭')
                // getData()
                // queryLinkMan(wxid)
            }
            this.settingTable.refresh()
        }, error => {
            Message.error('操作失败，请稍后重试！')
        })
    }

    //点击登录
    login = (obj) => {
        const {avatar, name, corpShortName, wxwUserId} = obj
        this.setState({
            data: {
                avatar: avatar,
                nickname: name,
                shortCorpName: corpShortName,
            },
            wxid: wxwUserId
        }, () => {
            this.settingModal.hide()
            this.loginRef.wxLogin()
        })
    }

    getColumns = () => {
        return [
            {
                title: `聊天企微号（${this.state.total}）`,
                // width: '200px',
                render: (text, record) => (
                    <ZkWxClient avatar={record.avatar} nickname={record.name} corpName={record.corpShortName}
                                friendType={1}/>
                )
            },
            {
                title: <TableTip text={'登录状态'} tip={'只能获取到在线状态下的聊天消息'}/>,
                render: (text, record) => (
                    <>
                        {/*//登录状态，0未登录，1登录*/}
                        {
                            record.loginStatus == 1 ?
                                <div className={'login_status_max'}>
                                    <div className={'seat_online'}></div>
                                    <div className={'on_line_text'}>在线</div>
                                </div> :
                                record.loginStatus == 2 ?
                                    <div className={'login_status_max'}>
                                        <div className={'seat_offline'}></div>
                                        <div className={'off_line_text'}>离线</div>
                                    </div> : '未知状态'
                        }
                    </>
                )
            },
            {
                title: <TableTip text={'在线聊天'} tip={'开关开启后该企微号会出现在在线聊天列表中'}/>,
                render: (text, record) => (
                    //聊天开启状态，1开启，0关闭
                    <Switch checkedChildren="开" unCheckedChildren="关" defaultChecked checked={record.openChat}
                            onClick={e => this.switch(record.wxwUserId, record.openChat == 1 ? 0 : 1, e)}/>
                )
            },
            {
                title: '操作',
                align: 'center',
                render: (text, record) => (
                    <>
                        {
                            record.loginStatus != 1 ?
                                <Button type={'primary'} ghost className={'im-setting-btn'}
                                        onClick={() => this.login(record)}>登录
                                </Button> : '--'
                        }
                    </>
                )
            },
        ]
    }

    getData = (params, pageNum, pageSize) => {
        const {nickName, loginStatus} = this.state.zkParams
        let queryParam = {
            pageSize: 6,
            pageNum: pageNum,
            params: params,
        }
        let bodyData = {
            nickName: nickName,
            loginStatus: loginStatus,
        }
        return new Promise(resolve => {
            CloudApi.getChatSettingsList(queryParam, bodyData, data => {
                resolve(data)
                this.setState({
                    total: data.pagInfo.total
                })
            }, error => {
                Message.error('账号列表请求超时')
                resolve({})
            })
        })
    }

    onSearch = (value, e) => {
        // console.log('9898',value, e)
        const {zkParams} = this.state
        zkParams.nickName = value
        this.setState({
            zkParams: zkParams
        })
    }

    onSelect = (value) => {
        // console.log('9898',value)
        // 登录状态，0未登录，1登录
        const {zkParams, searchValue} = this.state
        zkParams.nickName = searchValue
        if (value == 1) {
            zkParams.loginStatus = 1
        } else if (value == 2) {
            zkParams.loginStatus = 2
        } else {
            zkParams.loginStatus = ''
        }
        this.setState({
            zkParams: zkParams
        })
    }

    onChange = (e, type) => {
        let value = e.target.value
        this.setState({
            [type]: value
        })
    }

    //点击聊天配置
    chatSetting = () => {
        this.settingModal.show()
        // this.settingTable.refresh()
        this.setState({
            zkParams: {
                nickName: '',
                loginStatus: '',
            },
        })
    }

    //聊天配置关闭后的回调
    settingClose = () => {
        this.setState({
            zkParams: {
                nickName: '',
                loginStatus: '',
            },
        })
    }

    render() {
        const {zkParams, data, wxid} = this.state
        return (
            <>
                <Space size={20}>
                    {/*<a className={'im-topEdit'}><span><IconChat/></span>在线聊天</a>*/}
                    {/*<a className={'im-topEdit'}><span><IconHistory/></span>聊天记录</a>*/}
                    <a className={'im-topEdit'} onClick={this.chatSetting}><span><IconSettings/></span>聊天配置</a>
                </Space>

                {/*{登录组件}*/}
                <ImLogin data={data} wxid={wxid} ref={r => this.loginRef = r}/>

                {/*{聊天配置modal}*/}
                <ZkModal title={'聊天配置'} ref={r => this.settingModal = r} width={1000} footer={null}
                         maskClosable={false} className={'im-setting-modal'}
                         afterClose={this.settingClose}
                         destroyOnClose
                >
                    <Space size={'middle'}>
                        <Search placeholder="搜索微信昵称和企微号" allowClear onSearch={this.onSearch} style={{width: 300}} onChange={e=>this.onChange(e, 'searchValue')}/>
                        <Select placeholder="登录状态" style={{width: 200}} allowClear onChange={this.onSelect} defaultValue={9}>
                            <Option value={9}>全部</Option>
                            <Option value={1}>在线</Option>
                            <Option value={2}>离线</Option>
                        </Select>
                    </Space>
                    <div style={{height: '20px'}}></div>
                    <ZKTable
                        ref={r => this.settingTable = r}
                        params={zkParams}
                        owncolumns={this.getColumns}
                        queryAction={this.getData}
                        className={'qy-table-border'}
                    />
                </ZkModal>
            </>
        );
    }
}

export default TopEdit;